import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SbDateTime, SbLocalDateTime } from '../../../../services/api/api-date-time';
import { MsOptions } from 'src/app/services/global/global-interfaces';
import { ErrorService } from 'src/app/services/error.service';
import { API } from 'src/app/services/api/api';
import { UtilService } from 'src/app/services/util.service';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { ExportModalOptions } from 'src/app/services/gui/modal/sb-export-modal/sb-export-modal.model';
import { SbExportModalComponent } from 'src/app/services/gui/modal/sb-export-modal/sb-export-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-device-details-log',
  templateUrl: './device-details-log.component.html',
  styleUrls: ['./device-details-log.component.scss'],
  standalone: false,
})
export class DeviceDetailsLogComponent implements OnInit {
  deviceId: number;
  date: SbDateTime;

  msDatatypeOptions: MsOptions;
  filteredDatatypes: { id: string }[];
  datatypes: { id: string }[];

  constructor(
    private activatedRoute: ActivatedRoute,
    public api: API,
    public modal: ModalService,
    private translate: TranslateService,
    private errorHandler: ErrorService,
    public util: UtilService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.parent.params.subscribe(params => {
      this.deviceId = +params.deviceID;
    });
  }

  handleDateChange(date: SbLocalDateTime) {
    if (date) {
      this.date = new SbDateTime(date.value);
    }
  }

  msRequest(options?: MsOptions) {
    if (options) {
      this.msDatatypeOptions = options;
    }
    if (this.msDatatypeOptions?.pagination) {
      this.api
        .ss_nm_DeviceLog_datatypes(
          {
            search: this.util.encodeSearchQueryParam(false, this.msDatatypeOptions?.search),
          },
          this.msDatatypeOptions.pagination
        )
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: (datatypes: string[]) => {
            const arr: { id: string }[] = [];
            for (const dtype of datatypes) {
              arr.push({ id: dtype });
            }
            this.datatypes = [];
            this.datatypes = arr;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }

  msUpdate($event: { id: string }[]) {
    if ($event && $event?.length > 0) {
      this.filteredDatatypes = $event;
    } else {
      this.filteredDatatypes = [];
    }
  }

  export(): void {
    const exportOptions: ExportModalOptions = {
      kind: 'DEVICE_LOG',
      id: this.deviceId,
    };
    this.modal
      .showNavigationModal({
        entryComponent: {
          value: SbExportModalComponent,
          data: exportOptions,
        },
        title: this.translate.instant('lang.globals.device') + ' ' + this.deviceId,
        modalOptions: { size: 'lg' },
      })
      .then(() => {})
      .catch(() => {});
  }
}
